/**
 * Created by Ning Jiang on 3/13/2018.
 */

import {
    BetLineWinIndividualWPController
} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import {
    IIndividualWinPresentationConfig
} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SymbolBurstAnimator} from "../../reelsymbol/SymbolBurstAnimator";
import {Timeline, TimelineLite} from "gsap";
import {WildNudge} from "../../WildNudge";
import {WildNudgeParsedGameData} from "../../server/data/WildNudgeParsedGameData";
import {BelowStakeWinRestriction} from "../../server/BelowStakeWinRestriction";

export class WildNudgeIndividualWPController extends BetLineWinIndividualWPController {

    private _highlightAlpha:number = 0.7;
    private _betLineDelay:number = 0.5;

    private _belowStakeWinRestriction:boolean;

    constructor(config:IIndividualWinPresentationConfig) {
        super(config, "IndividualWin", true);

        this.addTweakModuleSlider({
            text : "Individual Win Highlight Alpha",
            minValue : 0.1,
            maxValue : 1.0,
            startValue : this._highlightAlpha,
            onValueChangeCallback : (text:string, newValue:number) => {
                this._highlightAlpha = newValue;
            }
        });

        this.addTweakModuleSlider({
            text : "Individual Win BetLine Delay",
            minValue : 0.1,
            maxValue : 2.0,
            startValue : this._betLineDelay,
            onValueChangeCallback : (text:string, newValue:number) => {
                this._betLineDelay = newValue;
            }
        });
    }

    protected parseFeatureGameData(data:WildNudgeParsedGameData) {
        this._belowStakeWinRestriction = BelowStakeWinRestriction.isWinBelowPlayedBetValue(data.singleWin, data.playedBetValue);
    }

    protected getLineAnimation(betLineWinData:IBetLineWinData):Timeline {
        const timeline:TimelineLite = <TimelineLite>super.getLineAnimation(betLineWinData);
        timeline.add(() => {}, `+=${this._betLineDelay}`);

        return timeline;
    }

    protected addSymbolWinAnimationToTimeline(betLineWinData:IBetLineWinData, timeline:Timeline, startTime:number, symbol:StateReelSymbol, reelId:number, symbolId:number):void {
        if(this._belowStakeWinRestriction) {
            return;
        }

        super.addSymbolWinAnimationToTimeline(betLineWinData, timeline, startTime, symbol, reelId, symbolId);

        timeline.add(SymbolBurstAnimator.playIdleFireWin(reelId, symbolId, [0], 20, this.getBurstAlpha(symbol.symName!)), startTime);
        if(reelId === 2) {
            let winText = WildNudge.api.currency.formatValue(betLineWinData.amount);
            if(betLineWinData.multiplier > 1) {
                winText += `X${betLineWinData.multiplier}`;
            }
            timeline.add(() => {
                SymbolBurstAnimator.playIdleWinText(reelId, symbolId, winText);
            }, startTime);
        }
    }

    private getBurstAlpha(symbolName:string):number {
        const char:string = symbolName.charAt(0);
        if(char === "M" || char === "W") {
            return 1;
        }
        return this._highlightAlpha;
    }

    protected stopWinPresentation(isAbort:boolean):void {
        super.stopWinPresentation(isAbort);

        SymbolBurstAnimator.abortWin();
    }
}